import { render, staticRenderFns } from "./kuaishouBuy.vue?vue&type=template&id=39eef061&scoped=true&"
import script from "./kuaishouBuy.vue?vue&type=script&lang=js&"
export * from "./kuaishouBuy.vue?vue&type=script&lang=js&"
import style0 from "./kuaishouBuy.vue?vue&type=style&index=0&id=39eef061&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eef061",
  null
  
)

export default component.exports